// Account API
import {
    AccountFilterRequestResponse,
    AccountFilterRequestSelectorResponse,
    AccountResponse,
} from 'app/Apps/AccountManagement/Accounts/Account.types'
import {
    RequestConfigFunction, SelectorConfig,
} from 'app/types/request.types'
import {
    WithId,
} from 'app/types/common.types'

type AccountRequests = {
    filterRequest: RequestConfigFunction<
        { params?: Record<string, any> }, AccountFilterRequestResponse
    >,
    get: RequestConfigFunction<WithId<number>, AccountResponse>,
    update: RequestConfigFunction<WithId<number>>,
    create: RequestConfigFunction,
    selector: ({
        params, includeFilters,
    }
    ?: {
        params?: Record<string, any>,
        includeFilters?: Record<string, any>,
    }) => SelectorConfig<{ companyName: string, id: number }[]>, // TODO-DK: remove selector configs
    archive: RequestConfigFunction<WithId<number>>,
    restore: RequestConfigFunction<WithId<number>>,
    getContactsByAccount: RequestConfigFunction<{
        accountId: number,
        params: Record<string, any>,
    }>,
    getRegionalGroupsByAccount: RequestConfigFunction<{ accountId: number }>,
    filterCountRequestContacts: RequestConfigFunction<{ accountId: number }>,
    getAccounts: RequestConfigFunction<
        { params?: Record<string, any> }, { items: AccountFilterRequestSelectorResponse[] }
    >,
}

export const accountConversion = (accounts) => {
    return accounts.map(({
        companyName, id,
    }) => {
        return {
            label: companyName,
            value: id,
            id,
        }
    })
}

const accountRequests: AccountRequests = {
    filterRequest: ({
        params = {},
    } = {}) => {
        return {
            url: 'account/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `account/${id}`,
            method: 'GET',
        }
    },
    update: ({
        id,
    }) => {
        return {
            url: `account/${id}`,
            method: 'PUT',
        }
    },
    create: () => {
        return {
            url: 'account',
            method: 'POST',
        }
    },
    archive: ({
        id,
    }) => {
        return {
            url: `account/${id}/archive`,
            method: 'PATCH',
        }
    },
    restore: ({
        id,
    }) => {
        return {
            url: `account/${id}/restore`,
            method: 'PATCH',
        }
    },
    getContactsByAccount: ({
        accountId,
        params = {},
    }) => {
        return {
            url: `account/${accountId}/contact/filter-request/all`,
            method: 'POST',
            ...params,
        }
    },
    getRegionalGroupsByAccount: ({
        accountId,
    }) => {
        return {
            url: `account/${accountId}/regionalgroup/fields`,
            method: 'GET',
        }
    },
    filterCountRequestContacts: ({
        accountId,
    }) => {
        return {
            url: `account/${accountId}/contact/filter-request/all`,
            method: 'POST',
        }
    },
    getAccounts: (params) => {
        return {
            url: 'account/filter-request/selector',
            method: 'POST',
            data: {
                ...params,
            },
        }
    },
    selector: ({
        params, includeFilters,
    } = {}) => {
        return {
            url: 'account/filter-request/selector',
            convertion: accountConversion,
            params,
            includeFilters,
        }
    },
}

export default accountRequests
